import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import api from "../../utils/api";
import { FILE_BASE_URL } from "../../utils/api";

const PrintJournalistView = () => {
  const { id } = useParams();
  const [journalist, setJournalist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [statements, setStatements] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [institutions, setInstitutions] = useState([]);

  useEffect(() => {
    fetchJournalist();
  }, []);

  const fetchJournalist = async () => {
    try {
      const response = await api.get(`/journalists/${id}`);
      if (response.data && response.data.data) {
        const journalistData = response.data.data;
        setJournalist(journalistData);

        // تحميل الصور
        if (journalistData.images) {
          try {
            setImages(parseArrayField(journalistData.images));
          } catch (e) {
            setImages([]);
          }
        }

        // تحميل التصريحات الجديدة
        if (journalistData.statements) {
          try {
            setStatements(parseArrayField(journalistData.statements));
          } catch (e) {
            console.error("فشل في قراءة التصريحات:", e);
            setStatements([]);
          }
        }

        // تحميل الخبرات العملية
        if (journalistData.professional_experiences) {
          try {
            setExperiences(parseArrayField(journalistData.professional_experiences));
          } catch (e) {
            setExperiences([]);
          }
        }

        // تحميل المؤسسات
        if (journalistData.media_institutions) {
          try {
            setInstitutions(parseArrayField(journalistData.media_institutions));
          } catch (e) {
            setInstitutions([]);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching journalist:", error);
    } finally {
      setLoading(false);
    }
  };

  const parseArrayField = (field) => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    try {
      return JSON.parse(field);
    } catch {
      return [];
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "white",
          padding: "40px",
          textAlign: "center",
          border: "1px solid #ddd"
        }}>
          <Spinner size="lg" />
          <p style={{ marginTop: "20px", fontSize: "18px" }}>جاري تحميل بيانات الصحفي...</p>
        </div>
      </div>
    );
  }

  if (!journalist) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "white",
          padding: "40px",
          textAlign: "center",
          border: "1px solid #ddd"
        }}>
          <i className="mdi mdi-alert-circle" style={{ fontSize: "64px", color: "#666" }}></i>
          <h4 style={{ marginTop: "20px" }}>لم يتم العثور على بيانات الصحفي</h4>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f5f5f5",
      padding: "20px"
    }}>
      <div className="container" style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <div style={{
          background: "white",
          border: "1px solid #ddd"
        }}>

          {/* هيدر الصحفي */}
          <div style={{
            background: "#f8f8f8",
            color: "#333",
            padding: "40px",
            borderBottom: "1px solid #ddd"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
              <div style={{ flexShrink: 0 }}>
                {journalist.profile_image ? (
                  <img
                    src={`${FILE_BASE_URL}/uploads/images/${journalist.profile_image}`}
                    alt="صورة الصحفي"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      border: "1px solid #ddd"
                    }}
                  />
                ) : (
                  <div style={{
                    width: "150px",
                    height: "150px",
                    background: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #ddd"
                  }}>
                    <i className="mdi mdi-account-tie" style={{ fontSize: "60px", color: "#999" }}></i>
                  </div>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h1 style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  color: "#333"
                }}>
                  {journalist.full_name || "بدون اسم"}
                </h1>

                <div style={{
                  display: "inline-block",
                  background: "#e0e0e0",
                  padding: "8px 20px",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  marginBottom: "20px"
                }}>
                  {journalist.specialization || "صحفي"}
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px" }}>
                  {journalist.mobile1 && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-cellphone" style={{ fontSize: "18px", color: "#666" }}></i>
                      <span>{journalist.mobile1}</span>
                    </div>
                  )}
                  {journalist.email && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-email" style={{ fontSize: "18px", color: "#666" }}></i>
                      <span>{journalist.email}</span>
                    </div>
                  )}
                  {(journalist.city_or_area || journalist.country_province) && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-map-marker" style={{ fontSize: "18px", color: "#666" }}></i>
                      <span>{[journalist.country || 'فلسطين', journalist.country_province, journalist.city_or_area].filter(Boolean).join(", ")}</span>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ textAlign: "center" }}>
                <button
                  onClick={handlePrint}
                  style={{
                    background: "#333",
                    border: "none",
                    color: "white",
                    padding: "12px 24px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    minWidth: "120px"
                  }}
                >
                  <i className="mdi mdi-printer me-2"></i>
                  طباعة
                </button>
              </div>
            </div>
          </div>

          <div style={{ padding: "40px" }}>
            
            {/* نبذة عن الصحفي */}
            {journalist.description && (
              <div style={{ marginBottom: "40px", padding: "20px" }}>
                <h3 style={{
                  color: "#333",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "2px solid #333",
                  paddingBottom: "10px"
                }}>
                  نبذة شخصية
                </h3>
                <div style={{
                  background: "#f9f9f9",
                  padding: "25px",
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  color: "#333",
                  border: "1px solid #ddd"
                }}>
                  {journalist.description.replace(/<[^>]*>/g, "")}
                </div>
              </div>
            )}

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "30px",
              marginBottom: "40px"
            }}>

              {/* المعلومات الشخصية */}
              <div style={{
                background: "white",
                padding: "30px",
                border: "1px solid #ddd"
              }}>
                <h4 style={{
                  color: "#333",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold"
                }}>
                  المعلومات الشخصية
                </h4>

                {[
                  { label: "الاسم الكامل", value: journalist.full_name, icon: "account" },
                  { label: "التخصص", value: journalist.specialization, icon: "school" },
                  { label: "اللغات", value: journalist.languages, icon: "translate" },
                  { label: "المهارات", value: journalist.skills, icon: "star" },
                  { label: "تاريخ الميلاد", value: journalist.birth_date, icon: "calendar" },
                  { label: "النوع الاجتماعي", value: journalist.gender, icon: "human-male-female" }
                ].filter(item => item.value).map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 0",
                    borderBottom: index < 5 ? "1px solid #eee" : "none"
                  }}>
                    <i className={`mdi mdi-${item.icon}`} style={{
                      fontSize: "18px",
                      color: "#666",
                      marginLeft: "12px",
                      minWidth: "18px"
                    }}></i>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "600", color: "#333", fontSize: "13px", marginBottom: "2px" }}>
                        {item.label}
                      </div>
                      <div style={{ color: "#555", fontSize: "15px" }}>{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* معلومات الاتصال */}
              <div style={{
                background: "white",
                padding: "30px",
                border: "1px solid #ddd"
              }}>
                <h4 style={{
                  color: "#333",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold"
                }}>
                  معلومات الاتصال
                </h4>

                {[
                  { label: "الجوال الأول", value: journalist.mobile1, icon: "cellphone" },
                  { label: "الجوال الثاني", value: journalist.mobile2, icon: "cellphone" },
                  { label: "البريد الإلكتروني", value: journalist.email, icon: "email" },
                  { label: "واتساب", value: journalist.whatsapp, icon: "whatsapp" },
                  { label: "فيسبوك", value: journalist.facebook, icon: "facebook" },
                  { label: "تويتر", value: journalist.twitter, icon: "twitter" }
                ].filter(item => item.value).map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 0",
                    borderBottom: index < 5 ? "1px solid #eee" : "none"
                  }}>
                    <i className={`mdi mdi-${item.icon}`} style={{
                      fontSize: "18px",
                      color: "#666",
                      marginLeft: "12px",
                      minWidth: "18px"
                    }}></i>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "600", color: "#333", fontSize: "13px", marginBottom: "2px" }}>
                        {item.label}
                      </div>
                      <div style={{ color: "#555", fontSize: "15px" }}>{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* العنوان والموقع */}
              <div style={{
                background: "white",
                padding: "30px",
                border: "1px solid #ddd",
                gridColumn: "1 / -1"
              }}>
                <h4 style={{
                  color: "#333",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold"
                }}>
                  العنوان والموقع
                </h4>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
                  <div style={{
                    background: "#f9f9f9",
                    padding: "20px",
                    border: "1px solid #ddd"
                  }}>
                    <h6 style={{ color: "#333", fontWeight: "bold", marginBottom: "15px" }}>
                      تفاصيل العنوان
                    </h6>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div><strong>الدولة:</strong> {journalist.country || "فلسطين"}</div>
                      <div><strong>المحافظة:</strong> {journalist.country_province || "-"}</div>
                      <div><strong>المدينة/المنطقة:</strong> {journalist.city_or_area || "-"}</div>
                      <div><strong>تفاصيل العنوان:</strong> {journalist.address_details || "-"}</div>
                    </div>
                  </div>

                  <div style={{
                    background: "#f9f9f9",
                    padding: "20px",
                    border: "1px solid #ddd"
                  }}>
                    <h6 style={{ color: "#333", fontWeight: "bold", marginBottom: "15px" }}>
                      معلومات إضافية
                    </h6>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div><strong>الحالة الاجتماعية:</strong> {journalist.marital_status || "-"}</div>
                      <div><strong>العمل الحالي:</strong> {journalist.current_job || "-"}</div>
                      <div><strong>الموقع الشخصي:</strong> {journalist.website || "-"}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* المؤسسات الإعلامية */}
            {institutions && institutions.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #9b59b6",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-domain" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  المؤسسات الإعلامية ({institutions.length})
                </h3>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
                  {institutions.map((institution, index) => (
                    <div key={index} style={{
                      background: "linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "1px solid rgba(155,89,182,0.2)",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                    }}>
                      <h6 style={{ color: "#9b59b6", fontWeight: "bold", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {institution.name || `مؤسسة ${index + 1}`}
                      </h6>
                      <div style={{ display: "grid", gap: "8px", fontSize: "14px", color: "#2c3e50" }}>
                        {institution.position && <div><strong>المنصب:</strong> {institution.position}</div>}
                        {institution.period && <div><strong>الفترة:</strong> {institution.period}</div>}
                        {institution.description && <div><strong>الوصف:</strong> {institution.description}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* الخبرات العملية */}
            {experiences && experiences.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #e67e22",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #e67e22 0%, #d35400 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-briefcase" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  الخبرات العملية ({experiences.length})
                </h3>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
                  {experiences.map((experience, index) => (
                    <div key={index} style={{
                      background: "linear-gradient(135deg, #fdeee6 0%, #fcebda 100%)",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "1px solid rgba(230,126,34,0.2)",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                    }}>
                      <h6 style={{ color: "#e67e22", fontWeight: "bold", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {experience.title || `خبرة ${index + 1}`}
                      </h6>
                      <div style={{ display: "grid", gap: "8px", fontSize: "14px", color: "#2c3e50" }}>
                        {experience.company && <div><strong>الجهة:</strong> {experience.company}</div>}
                        {experience.duration && <div><strong>المدة:</strong> {experience.duration}</div>}
                        {experience.description && <div><strong>الوصف:</strong> {experience.description}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* التصريحات الجديدة */}
            {statements && statements.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #f39c12",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #f39c12 0%, #e67e22 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-comment-quote" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  التصريحات والأقوال ({statements.length})
                </h3>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", gap: "20px" }}>
                  {statements.map((statement, index) => (
                    <div key={index} style={{
                      background: "linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "1px solid rgba(243,156,18,0.2)",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                    }}>
                      <h6 style={{ color: "#f39c12", fontWeight: "bold", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {statement.title || `تصريح ${index + 1}`}
                      </h6>
                      <div 
                        style={{
                          color: "#2c3e50",
                          lineHeight: "1.6",
                          marginBottom: "15px",
                          fontSize: "14px"
                        }}
                        dangerouslySetInnerHTML={{ __html: statement.content }}
                      />
                      {statement.date && (
                        <div style={{
                          fontSize: "13px",
                          color: "#7f8c8d",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px"
                        }}>
                          <i className="mdi mdi-calendar"></i>
                          {new Date(statement.date).toLocaleDateString('ar-EG')}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* معرض الصور */}
            {images && images.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #27ae60",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-image-multiple" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  معرض الصور ({images.length})
                </h3>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                  gap: "20px"
                }}>
                  {images.slice(0, 6).map((image, index) => (
                    <div key={index} style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
                    }}>
                      <img
                        src={`${FILE_BASE_URL}/uploads/images/${image}`}
                        alt={`صورة ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "150px",
                          objectFit: "cover"
                        }}
                      />
                      <div style={{
                        padding: "10px",
                        background: "white",
                        textAlign: "center",
                        fontSize: "13px",
                        color: "#7f8c8d"
                      }}>
                        صورة {index + 1}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintJournalistView;